import React, {Component} from 'react'
import Base from '../BaseComponent'
import Image from '../../utils/Image'
import Video from '../../utils/Video'
import Asset from '../../models/Asset'

import withData from '../../utils/withData';

class Media extends Component {

  render () {


  	let settings = {};

	let _this = this;
    let assetId = this.props.id
    let {assets} = this.props.data;
    
    if(this.props.videoId) assetId = this.props.videoId


    let asset = assets.find((a) => (a.id == assetId));

    if(!asset) return null;


    if(asset.kind == 'video')
    {
        return (
        <Asset id={[assetId]} render={(item) => {

                    if(_this.props.fluid == false){
                let ratio = this.props.ratio || item.width/item.height;
                        settings = {ratio:ratio};
                    }else{

                        settings = {fluid:true};

                    }


                    return  (<Video {...settings } src={item.sizes.local} />)

            }


        }/>

    )
    }
     else {
        return (
        <Asset id={[assetId]} render={(item) => {

                    if(_this.props.fluid == false){
                let ratio = this.props.ratio || item.width/item.height;
                        settings = {ratio:ratio};
                    }else{

                        settings = {fluid:true};

                    }

                    return  (<Image {...settings } small={(_this.props.original) ? item.sizes.local : item.sizes.small} large={(_this.props.original) ? item.sizes.local : item.sizes.medium} />)

            }


        }/>

    )
     }

    
  }
}

export default withData(Media)



// WEBPACK FOOTER //
// ./src/js/components/Media/Media.jsx